<div class="content-info">
  <div class="content-title">
    <h3 class="title">
      {{
        activeTab === 'to_receive'
          ? 'Awaiting Receipt'
          : activeTab === 'in_progress'
          ? 'Receipts In Progress'
          : 'Received Transfers'
      }}
    </h3>
    <div class="title-actions">
      @if (activeTab === 'received') {
      <button type="button" class="btn btn-sm" [class.btn-outline-primary]="showOnlyDiscrepancy"
        [class.active]="showOnlyDiscrepancy" [class.btn-outline-secondary]="!showOnlyDiscrepancy"
        (click)="toggleDiscrepancyFilter()">
        <i class="bi bi-exclamation-triangle"></i>
        Only with discrepancy
      </button>
      }
      <label class="zf-search" title="Search by transfer number">
        <i class="bi bi-search"></i>
        <input type="text" [(ngModel)]="searchTerm" (input)="onSearch()" placeholder="Search transfer number" />
      </label>
    </div>
  </div>

  <div class="zf-card-head">
    <div class="zf-tabs">
      <button type="button" class="zf-tab" [class.active]="activeTab === 'to_receive'" (click)="setTab('to_receive')">
        In Transit
      </button>
      <button type="button" class="zf-tab" [class.active]="activeTab === 'in_progress'" (click)="setTab('in_progress')">
        In Progress (Draft)
      </button>
      <button type="button" class="zf-tab" [class.active]="activeTab === 'received'" (click)="setTab('received')">
        Received
      </button>
    </div>
    <div class="zf-tabs-right ms-auto">
      @if (activeTab === 'to_receive') {
      Stock shipped to your locations and waiting to be received. Click <strong>&nbsp;Receive&nbsp;</strong> to record what arrived.
      } @else if (activeTab === 'in_progress') {
      Receipts you've started but not yet posted. Continue where you left off.
      } @else {
      Completed receipts. Rows marked <span class="zf-status warn mx-1"><i class="bi bi-exclamation-triangle"></i> Discrepancy</span> had missing or short units.
      }
    </div>
  </div>

  <div class="common-table">
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            @if (activeTab === 'to_receive') {
            <th>Transfer Number</th>
            <th>From Location</th>
            <th>To Location</th>
            <th>Sent On</th>
            <th class="zf-num">Total Units</th>
            <th class="zf-num">Total Amount</th>
            <th>Status</th>
            <th>Action</th>
            } @else {
            <th>Transfer In Number</th>
            <th>Transfer Out Number</th>
            <th>From Location</th>
            <th>To Location</th>
            <th>Date</th>
            <th class="zf-num">Total Units</th>
            <th class="zf-num">Total Amount</th>
            <th>Status</th>
            <th>Action</th>
            }
          </tr>
        </thead>
        <tbody>
          @if (transferLoading) {
          <tr>
            <td [attr.colspan]="activeTab === 'to_receive' ? 8 : 9" class="text-center">Loading transfers…</td>
          </tr>
          } @else if (!currentList.length) {
          <tr>
            <td [attr.colspan]="activeTab === 'to_receive' ? 8 : 9">
              <div class="zf-empty">
                @if (activeTab === 'to_receive') {
                <strong>Nothing waiting to be received</strong>
                <span>Transfers shipped to this location will appear here.</span>
                } @else if (activeTab === 'in_progress') {
                <strong>No receipts in progress</strong>
                <span>Start receiving from the In Transit tab.</span>
                } @else {
                <strong>No received transfers yet</strong>
                <span>Posted receipts will be listed here.</span>
                }
              </div>
            </td>
          </tr>
          } @else {

          <!-- To Receive: rows are TOs (incoming + IN_TRANSIT) -->
          @if (activeTab === 'to_receive') { @for (transfer of currentList; track transfer.id) {
          <tr>
            <td class="zf-key">
              <a [routerLink]="['/transfer-out/edit', transfer.id]" [queryParams]="{ view: true }">{{ transfer.transferOutNumber }}</a>
            </td>
            <td>{{ transfer?.sourceLocation?.name || '-' }}</td>
            <td>{{ transfer?.targetLocation?.name || '-' }}</td>
            <td class="zf-mono">{{ transfer.createdAt | date : 'dd-MM-yy' }}</td>
            <td class="zf-num">{{ transfer.totalQty || 0 }}</td>
            <td class="zf-num zf-strong">{{ transfer.totalAmount || 0 | number : '1.2-2' }}</td>
            <td>
              <span class="zf-status warn"><i class="bi bi-truck"></i> In Transit</span>
            </td>
            <td>
              <div class="td-actions-btn">
                <button class="btn btnprimary btn-sm" style="width: auto; padding: 0 12px"
                  [routerLink]="['/transfer-in/create', transfer.id]" title="Receive this transfer">
                  <i class="bi bi-box-arrow-in-down"></i> Receive
                </button>
              </div>
            </td>
          </tr>
          } }

          <!-- In Progress / Received: rows are TIs -->
          @else { @for (transfer of currentList; track transfer.id) {
          <tr>
            <td class="zf-key">
              <a [routerLink]="['/transfer-in/edit', transfer.id]" [queryParams]="{ view: true }">{{ transfer.transferInNumber }}</a>
            </td>
            <td class="zf-mono zf-dim">
              <a [routerLink]="['/transfer-out/edit', transfer.stockTransferOut?.id]" [queryParams]="{ view: true }">
                {{ transfer.stockTransferOut?.transferOutNumber }}
              </a>
            </td>
            <td>{{ transfer?.stockTransferOut?.sourceLocation?.name || '-' }}</td>
            <td>{{ transfer?.stockTransferOut?.targetLocation?.name || '-' }}</td>
            <td class="zf-mono">{{ transfer.createdAt | date : 'dd-MM-yy' }}</td>
            <td class="zf-num">{{ transfer.totalQty || 0 }}</td>
            <td class="zf-num zf-strong">{{ transfer.totalAmount || 0 | number : '1.2-2' }}</td>
            <td>
              @if (activeTab === 'in_progress') {
              <span class="zf-status"><i class="bi bi-pencil-square"></i> Draft</span>
              } @else { @if (transfer.partiallyReceived) {
              <span class="zf-status warn"><i class="bi bi-exclamation-triangle"></i> Received with discrepancy</span>
              } @else {
              <span class="zf-status ok"><i class="bi bi-check2-circle"></i> Received</span>
              } }
            </td>
            <td>
              <div class="td-actions-btn">
                @if (activeTab === 'in_progress') {
                <button class="btn btn-edit" [routerLink]="['/transfer-in/edit', transfer.id]" title="Continue receiving">
                  <i class="bi bi-pencil-square"></i>
                </button>
                <button class="btn" style="color: var(--zf-ok)" (click)="finalizeTransfer(transfer.id)" title="Post receipt">
                  <i class="bi bi-check2-circle"></i>
                </button>
                } @else {
                <button class="btn btn-edit" [routerLink]="['/transfer-in/edit', transfer.id]" [queryParams]="{ view: true }"
                  title="View">
                  <i class="bi bi-eye"></i>
                </button>
                }
              </div>
            </td>
          </tr>
          } } }
        </tbody>
      </table>
    </div>

    <app-pagination [page]="currentPage" [limit]="pageSize" [pageCount]="pageCount" (pageChange)="goToPage($event)"
      (limitChange)="onPageSizeChange($event)">
    </app-pagination>
  </div>
</div>
